<template>
  <div>
    <compWrapper title="应收金额费率" theme="primary">
      <compFormEdit
        ref="markupRate"
        class="margin-top-15"
        :formdata="getBase"
        v-model="formData"
      />
      <div class="text-right padding-bottom-20 padding-right-20">
        <Button type="primary" @click="submit">保存</Button>
        <Button class="margin-left-10" @click="cancel">取消</Button>
      </div>
    </compWrapper>
    <vLoading size="large" transfer :loading="loading"></vLoading>
  </div>
</template>
<script>
import { mapState, mapGetters } from "vuex";
import { HttpSaveMarkUpRate, HttpMarkUpRateOne } from "@/service/bespeak";
export default {
  props: ["activeids", "querytype"],
  data() {
    return {
      type: this.$route.params.type || this.querytype,
      id: this.$route.query.id || this.activeids,
      formData: {},
      loading: false,
    };
  },
  created() {
    if (this.type !== "add") {
      this.getDetail();
    }
  },
  computed: {
    ...mapGetters("dictionary", ["getBillcusorgList"]),
    getBase() {
      return [
        {
          label: this.$t("global.common.cusorg", {
            defaultValue: "客户组织",
          }),
          key: "orgId",
          tag: "vSelect",
          options: this.getBillcusorgList,
          props:{
            filterable:true,
          }
        },
        {
          label: this.$t("erp.b2c.shipping_method", {
            defaultValue: "发货方式",
          }),
          key: "shipType",
          tag: "vSelect",
          options: [
            { value: 1, label: "LTL" },
            { value: 2, label: "FTL" },
          ],
        },
        {
          label: this.$t("", {
            defaultValue: "应收金额加价率",
          }),
          key: "receiveAmountRate",
          tag: "vInputNumber",
          props: {
            min: 0,
          },
        },
        {
          label: this.$t("global.common.status", {
            defaultValue: "状态",
          }),
          tag: "vSelect",
          key: "status",
          options: [
            { value: 1, label: "启用" },
            { value: 0, label: "停用" },
          ],
        },
        {
          label: this.$t("", {
            defaultValue: "应收保险加价率",
          }),
          key: "receiveInsuranceAmountRate",
          tag: "vInputNumber",
          props: {
            min: 0,
          },
          required: false,
        },
      ];
    },
  },
  methods: {
    getDetail() {
      this.loading = true;
      HttpMarkUpRateOne({
        id: this.id,
      }).then(
        (res) => {
          this.formData = res.data;
          this.loading = false;
        },
        (err) => {
          this.$VMessage.error(err.message);
        }
      );
    },
    async submit() {
      const valid = await this.$refs.markupRate.validate();
      if (!valid) return;
      this.loading = true;
      HttpSaveMarkUpRate({
        ...this.formData,
      }).then(
        (res) => {
          this.$VMessage.success(res.message);
          this.cancel();
          this.loading = false;
        },
        (err) => {
          this.loading = false;
          this.$VMessage.error(err.message);
        }
      );
    },
    cancel() {
      this.$router.push({
        name: "markupRateList",
      });
    },
  },
};
</script>
